import { createAction, props } from "@ngrx/store";
import { StandingInstruction } from "../../shared/types/StandingInstruction";
import { TableColumn } from "../../shared/types/TableColumn";
import { transactionTypes, ViewTypes } from "../../shared/utilities/Constants";
import { CashieringTransaction, RecurringTransaction } from "../models";
import { InternalTransferAcknowledgeResponse } from "../models/internal-transfer/InternalTransferAcknowledgeResponse";
import { InternalTransferInputRequest } from "../models/internal-transfer/InternalTransferInputRequest";
import { InternalTransferInputResponse } from "../models/internal-transfer/InternalTransferInputResponse";
import { InternalTransferInquiryResponse } from "../models/internal-transfer/InternalTransferInquiryResponse";
import { InternalTransferPositionsResponse } from "../models/internal-transfer/InternalTransferPositionsResponse";
import { InternalTransferVerifyResponse } from "../models/internal-transfer/InternalTransferVerifyResponse";
import { ServiceError, ServiceErrorWithList } from "../models/shared/ServiceError";

export const toAccountEntered = createAction(
    '[Create Request - Internal Transfer] To Account Entered',
    props<{ payload: InternalTransferInputRequest }>()
);

export const standingAuthSelected = createAction(
    '[Create Request - Internal Transfer] Standing Auth Selected',
    props<{ payload: InternalTransferInputRequest }>()
);

export const callInquiry = createAction(
    '[Create Request - Internal Transfer] Call inquiry',
    props<{ payload: StandingInstruction | CashieringTransaction | RecurringTransaction, viewType: ViewTypes, transactionType: transactionTypes }>()
);

export const extraPromptUpdated = createAction(
    '[Create Request - Internal Transfer] Extra prompt updated'
);

export const loadToAccountSuccess = createAction(
    '[Create Request - Internal Transfer] To Account Successfully loaded',
    props<{ internalTransferInputResponse: InternalTransferInputResponse }>()
);

export const loadToAccountFinishedWithError = createAction(
    '[Create Request - Internal Transfer] Load to account has error',
    props<{ internalTransferInputResponse: InternalTransferInputResponse }>()
);

export const inquiryCallSuccessful = createAction(
    '[Create Request - Internal Transfer] Inquiry call successful',
    props<{ internalTransferInquiryResponse: InternalTransferInquiryResponse }>()
);

export const inquiryCallFail = createAction(
    '[Create Request - Internal Transfer] Inquiry call failed',
    props<ServiceError>()
);

export const loadToAccountFail = createAction(
    '[Create Request - Internal Transfer] Error loading To Account',
    props<ServiceError>()
);

export const updateRowData = createAction(
    '[Update Request - Positions Table] Update positions table value',
    props<{ response: TableColumn[] }>()
);

export const loadPositions = createAction(
    '[Create Request - Internal Transfer] Calling endpoint to get positions'
);

export const loadPositionsFail = createAction(
    '[Create Request - Internal Transfer] Call to get positions failed',
    props<ServiceError>()
);

export const loadPositionsSuccessful = createAction(
    '[Create Request - Internal Transfer] Call to get positions successfully loaded',
    props<{ internalTransferPositionsResponse: InternalTransferPositionsResponse }>()
);

export const transactionDetailsComponentLoaded = createAction(
    '[Create Request - Internal Transfer] Transaction Details Component Loaded'
);

export const verifyCallSuccessful = createAction(
    '[Create Request - Internal Transfer] Call to verify was successful',
    props<{ response: InternalTransferVerifyResponse }>()
);

export const verifyCallFinishedWithError = createAction(
    '[Create Request - Internal Transfer] Verify call has error',
    props<{ response: InternalTransferVerifyResponse }>()
);

export const verifyCallFail = createAction(
    '[Create Request - Internal Transfer] Error calling verify',
    props<ServiceError>()
);

export const callAcknowledge = createAction(
    '[Create Request - Internal Transfer] Call to internal transfer acknowledge'
);

export const acknowledgeCallSuccessful = createAction(
    '[Create Request - Internal Transfer] Call to internal transfer acknowledge was successful',
    props<{ response: InternalTransferAcknowledgeResponse }>()
);

export const acknowledgeCallFail = createAction(
    '[Create Request - Internal Transfer] Call to internal transfer acknowledge failed',
    props<ServiceErrorWithList>()
);

export const clearToAccount = createAction(
    '[Create Request - Internal Transfer] Clear to account'
);

export const nsfClientSideError = createAction(
  '[Create Request - Internal Transfer] Dig2Pdf sufficient funds check failed'
)

